import imageCompression from 'browser-image-compression';

const MAX_RECEIPT_SIZE_BYTES = 5 * 1024 * 1024;

/**
 * Downscale a receipt photo picked from the phone's gallery (not one taken with our own
 * in-app camera button) so it comfortably clears the backend's upload limit. Phone cameras
 * routinely produce 10-20+ MB photos; only files over the 5 MB threshold are touched, and any
 * file we fail to compress (e.g. a HEIC image the browser can't decode onto a canvas) is
 * returned unchanged — a large upload beats a blocked one.
 */
export async function compressReceiptImageIfNeeded(file: File): Promise<File> {
  if (!file.type.startsWith('image/') || file.size <= MAX_RECEIPT_SIZE_BYTES) {
    return file;
  }
  try {
    return await imageCompression(file, {
      maxSizeMB: 4.8,
      maxWidthOrHeight: 4096,
      useWebWorker: true,
    });
  } catch {
    return file;
  }
}
